import { useState } from 'react'
import { Checkbox, FormControlLabel, TextField } from '@mui/material'
import { Container } from './styles'
import { CadastroState } from '../../index'
import { Terms } from '../../../Terms'
import Dialog from '../../../Dialog'

// input password
import IconButton from '@mui/material/IconButton'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import InputAdornment from '@mui/material/InputAdornment'
import FormControl from '@mui/material/FormControl'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import Politica from '../../../TermosCondicoes/Politica'
import Adesao from '../../../TermosCondicoes/Adesao'
import CondicoesGerais from '../../../TermosCondicoes/CondicoesGerais'
import { BsEye, BsEyeSlash } from 'react-icons/bs'
import classNames from 'classnames'

interface Props {
    email: CadastroState
    password: CadastroState
    setPassword: (valor: string) => void
    passwordConfirm: CadastroState
    setPasswordConfirm: (valor: string) => void
    checkTerms: boolean
    setCheckTerms: (valor: boolean) => void
}

export default function ChooseCompanyPlanStep({
    email,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    checkTerms,
    setCheckTerms,
}: Props) {
    const [isTermsOpen, setIsTermsOpen] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    function handleClickShowPassword() {
        setShowPassword(!showPassword)
    }

    return (
        <Container>
            <div>
                {/* <TextField
                    onChange={(e) => setLogin(e.target.value)}
                    value={login}
                    sx={{ width: '100%' }}
                    label="Login"
                    type="text"
                /> */}
                <label
                    htmlFor="email-login"
                    className="text-gray-700 text-sm label block"
                >
                    Email
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="email-login"
                    name="email-login"
                    value={email}
                    disabled
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1 opacity-70'
                    )}
                    placeholder="Seu email"
                />
            </div>
            <div>
                {/* <FormControl sx={{ width: '100%' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">
                        Senha
                    </InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Password"
                    />
                </FormControl> */}
                <div className="relative">
                    <label
                        htmlFor="password"
                        className="text-gray-700 text-sm label"
                    >
                        Digite sua senha
                        <span className="text-red-500 required-dot">*</span>
                    </label>
                    <input
                        type={showPassword ? 'text' : 'password'}
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={classNames(
                            'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                        )}
                        placeholder="Digite sua senha"
                    />

                    {showPassword ? (
                        <button
                            type="button"
                            className="absolute text-gray-500 right-2 bottom-3"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <BsEyeSlash size={20} />
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="absolute text-gray-500 right-2 bottom-3"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <BsEye size={20} />
                        </button>
                    )}
                </div>
            </div>

            <div>
                {/* <FormControl sx={{ width: '100%' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-passwordConfirm">
                        Confirmar senha
                    </InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-passwordConfirm"
                        type={showPassword ? "text" : "password"}
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Password"
                    />
                </FormControl> */}
                <div className="relative">
                    <label
                        htmlFor="passwordConfirm"
                        className="text-gray-700 text-sm label"
                    >
                        Confirme sua senha
                        <span className="text-red-500 required-dot">*</span>
                    </label>
                    <input
                        type={showPassword ? 'text' : 'password'}
                        id="passwordConfirm"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        className={classNames(
                            'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                        )}
                        placeholder="Confirme sua senha"
                    />

                    {showPassword ? (
                        <button
                            type="button"
                            className="absolute text-gray-500 right-2 bottom-3"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <BsEyeSlash size={20} />
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="absolute text-gray-500 right-2 bottom-3"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            <BsEye size={20} />
                        </button>
                    )}
                </div>
            </div>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={checkTerms}
                        onChange={(e, newValue) => setCheckTerms(newValue)}
                    />
                }
                label={<Terms setIsTermsOpen={setIsTermsOpen} />}
            />

            <Dialog
                setCheckTerms={setCheckTerms}
                isTermsOpen={isTermsOpen}
                setIsTermsOpen={setIsTermsOpen}
                title="Termos de uso"
            >
                <Politica />
                <hr />
                <br />
                <CondicoesGerais />
                <br />
                <hr />
                <br />
                <Adesao />
            </Dialog>
        </Container>
    )
}
